import { Tag } from "antd";
import { getFullName } from "../../../../utils/shared";
import { renderContentWithLinks } from "../../ChatView/MessageItem/LinkUtils";
import { getStatusColor } from "../../ChatView/helper";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../../store/chats/slice";
import Avatar from "../../../../components/generic/Avatar";
import { convertDateToFromNow } from "../../../../utils/dayjs";
import { useMemo } from "react";
import { SYSTEM_SENDER } from "../../../../constant";

const SENDER_RESOLVERS = {
  system: () => SYSTEM_SENDER,
  user: (chat, senderId) => chat.members?.find((m) => m.id === senderId),
  customer: (chat, senderId) => chat.customers?.find((c) => c.id === senderId),
};

const ConvListItem = ({ chat, selectedChatId }) => {
  const dispatch = useDispatch();

  const lastMessageUserName = useMemo(() => {
    const { sender_type, sender_id } = chat?.last_message || {};

    const resolver = SENDER_RESOLVERS[sender_type];

    return getFullName(
      resolver ? resolver(chat, sender_id) : chat?.assigned_advisor,
    );
  }, [chat]);

  return (
    <div
      key={chat.id}
      className={`conversation-card ${
        selectedChatId === chat?.id ? "selected" : ""
      }`}
      onClick={() => {
        dispatch(
          setKeyValue({
            key: "topicQuestions",
            value: null,
          }),
        );
        dispatch(
          setKeyValue({
            key: "selectedChatId",
            value: chat?.id,
          }),
        );
      }}
    >
      <div className="avatar-section">
        <Avatar size={40} user={chat?.assigned_advisor} />
      </div>

      <div className="card-content">
        <div className="card-top">
          <div className="customer-name capitalize-text ellipsis-text">
            #{chat.display_id}&nbsp;
            {chat?.name ? chat?.name : `📍 ${chat.branch.name}`}
          </div>
          <span className="timestamp">
            {convertDateToFromNow(
              chat?.last_message?.sent_at || chat?.created_at,
            )}
          </span>
        </div>

        <div className="card-middle">
          <span className="last-message ellipsis-text">
            {renderContentWithLinks({
              text: chat?.last_message?.content,
              users: chat?.users,
              showLink: false,
            }) || "There is no message"}
          </span>

          <Tag className="capitalize-text" color={getStatusColor(chat.status)}>
            {chat.status}
          </Tag>
        </div>
        <div className="card-bottom">
          <span className="ticket-badge ellipsis-text">
            {lastMessageUserName}
          </span>
          <span className="topic-label">{chat.topic.name}</span>
        </div>
      </div>
    </div>
  );
};

export default ConvListItem;
